/* src/app/service-item/sync-dialog/sync-dialog-presenter/sync-dialog-presenter.component.scss */
:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}
.flexForm {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.radio-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem 1rem;
  align-items: center;
}
.radio-item {
  border: 1px solid var(--p-surface-200, #e2e8f0);
  border-radius: 0.25rem;
  padding: 0.5rem;
  margin: 0.5rem;
  background-color: var(--p-surface-50, #f8fafc);
  color: var(--p-text-color, #495057);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background-color 0.15s ease;
}
.radio-item:hover {
  border-color: var(--p-surface-300, #cbd5e1);
}
.radio-item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--p-primary-200, rgba(59, 130, 246, 0.25));
}
.radio-item-active {
  border-color: var(--p-primary-color, #3b82f6);
  background-color: var(--p-primary-50, #eff6ff);
}
:host-context(html.app-dark) .radio-item,
:host-context(body.dark-theme) .radio-item {
  border-color: var(--p-surface-600, #334155);
  background-color: var(--p-surface-700, #334155);
  color: var(--p-text-color, #e2e8f0);
}
:host-context(html.app-dark) .radio-item:hover,
:host-context(body.dark-theme) .radio-item:hover {
  border-color: var(--p-surface-500, #475569);
}
:host-context(html.app-dark) .radio-item:focus-visible,
:host-context(body.dark-theme) .radio-item:focus-visible {
  box-shadow: 0 0 0 2px var(--p-primary-700, rgba(56, 189, 248, 0.35));
}
:host-context(html.app-dark) .radio-item-active,
:host-context(body.dark-theme) .radio-item-active {
  border-color: var(--p-primary-700, #1d4ed8);
  background-color: var(--p-primary-color-dark, rgba(9, 50, 73, 0.6901960784));
  color: var(--p-primary-100, #e0f2fe);
}
.sync-dialog-content {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;
}
.button-bar {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
/*# sourceMappingURL=sync-dialog-presenter.component.css.map */
